import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 11 9" {...props}>
      <title>{props.title || 'Collection'}</title>
      <g
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
        transform="translate(-3.000000, -4.000000)"
      >
        <g transform="translate(3.000000, 4.500000)">
          <polygon points="0 1.18461536 9.05384614 1.18461536 9.05384614 0 0 0" />
          <polygon points="0 6.26153844 4.52692307 6.26153844 4.52692307 5.07692308 0 5.07692308" />
          <polygon points="5.92307692 6.26153844 11 6.26153844 11 5.07692308 5.92307692 5.07692308" />
          <polygon
            transform="translate(8.461538, 5.669231) rotate(-270.000000) translate(-8.461538, -5.669231) "
            points="5.92307692 6.26153844 11 6.26153844 11 5.07692308 5.92307692 5.07692308"
          />
          <polygon points="0 3.7230769 6.76923077 3.7230769 6.76923077 2.53846154 0 2.53846154" />
        </g>
      </g>
    </Icon>
  )
}
